import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import Tag from "~/common/components/Tag/Tag";
import { Checkbox, IconButton, Stack, Tooltip, Typography } from "~/common/mui";
import { useTranslation } from "react-i18next";
import type { OrderLineItemData } from "~/domains/orders/types/modelsV2";
import { OrderLineHeader } from "../common/components/v2/OrderAndQuoteSharedStyles";
import { TooltipWithArrow } from "~/common/components/TooltipWithArrow";
import { OrderLineInfoV2 } from "../orderDetailsV2/OrderDetailsV2/OrderLineInfoV2";

interface Props {
  data: OrderLineItemData;
  selectable?: boolean;
  selectionDisabled?: boolean;
  selected?: boolean;
  selectableIndexSet?: Set<number>;
  lineItemIndex: number;
  selectItem?: (itemIndex: number) => void;
  onDownload: () => void;
}

const OrderLineHeaderSection = ({
  data,
  selectable,
  selectionDisabled,
  selected,
  selectableIndexSet,
  lineItemIndex,
  selectItem,
  onDownload,
}: Props) => {
  const { t } = useTranslation();

  const renderTag = () => {
    if (!data.status) {
      return null;
    }

    if (data.invoiceData?.invoiceDate) {
      return (
        <Tooltip
          variant="rich"
          placement="top"
          arrow
          title={
            <Stack gap={0.5}>
              <Typography variant="bodySmall" color="text.label">
                {t("quoteDetailsPage.summary.invoiceDate")}
              </Typography>

              {data.invoiceData && <Typography variant="bodyLarge">{data.invoiceData.invoiceDate}</Typography>}
            </Stack>
          }
        >
          <Tag variant={data.status === "codes.lineItemStatus.06" ? "success" : "default"}>{t(data.status)}</Tag>
        </Tooltip>
      );
    }

    return <Tag variant={data.status === "codes.lineItemStatus.06" ? "success" : "default"}>{t(data.status)}</Tag>;
  };

  return (
    <OrderLineHeader>
      <Stack direction="row" gap={1} alignItems="center">
        <Checkbox
          sx={{ p: 0 }}
          disabled={selectionDisabled || !selectableIndexSet?.has(lineItemIndex)}
          checked={Boolean(selected)}
          onChange={() => selectItem?.(lineItemIndex)}
        />
        <OrderLineInfoV2 lineNo={data.lineNo} quoteNumber={data.quoteNumber} />
      </Stack>

      <Stack direction="row" gap={1} alignItems="center">
        {renderTag()}
        {data.invoiceData && (
          <TooltipWithArrow title={t("orderDetails.download.text")} placement="top">
            <IconButton onClick={onDownload}>
              <FileDownloadOutlinedIcon color="primary" />
            </IconButton>
          </TooltipWithArrow>
        )}
      </Stack>
    </OrderLineHeader>
  );
};

export default OrderLineHeaderSection;
